import { useEffect } from 'react';

import { getInitialValues } from 'hb-react/frontoffice/apps/Filters/form/getInitialValues';

// Resubmit initial values if url params changes from the menu
export const useUpdateFromMenu = (
  shouldUpdateFromMenu,
  handleSubmit,
  initialValues,
  formikRef,
  config,
  filters,
  search,
) => {
  useEffect(() => {
    if (shouldUpdateFromMenu()) {
      handleSubmit(initialValues);

      if (formikRef.current) {
        const searchParamsFilters = getInitialValues({
          filters,
          initialFiltersFromConfig: config.initialFilters,
          searchParamsFilters: Object.fromEntries(new URLSearchParams(search)),
        });

        formikRef.current.setValues(searchParamsFilters, false);
      }
    }
  }, [search]);
};
